import { UPDATE_INVENTORY, UPLOAD_INVENTORY } from "../../types";

// Initial state
const INITIAL_STATE = {
  showBulk: [],
  inventory: [],
};

const bulkReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  
  switch (type) {
    
    case UPLOAD_INVENTORY:
        // console.log('Reducer Payload:', payload);
      return {
        ...state,
        showBulk: [...payload],
      };

    case UPDATE_INVENTORY:
        return{
            ...state,
            inventory: [...state.inventory, payload]
        }
    
    default:
      return state;
  }
};

export default bulkReducer;
